const stats = [
  { value: "5", unit: "+", label: "Nhóm thí nghiệm chuyên ngành", icon: "ri-flask-2-line" },
  { value: "100", unit: "+", label: "Loại thí nghiệm khác nhau", icon: "ri-test-tube-line" },
  { value: "2018", unit: "", label: "Năm thành lập và hoạt động", icon: "ri-calendar-line" },
  { value: "TCVN", unit: "", label: "Tiêu chuẩn thực hiện", icon: "ri-shield-check-line" },
];

const certifications = [
  {
    icon: "ri-file-certificate-2-line",
    title: "Đăng ký kinh doanh",
    desc: "Số 0401923171 cấp ngày 10/09/2018 do Sở KH&ĐT TP. Đà Nẵng cấp",
  },
  {
    icon: "ri-government-line",
    title: "Chứng nhận năng lực",
    desc: "Hoạt động thí nghiệm chuyên ngành xây dựng được cơ quan nhà nước có thẩm quyền công nhận",
  },
  {
    icon: "ri-award-line",
    title: "Tiêu chuẩn thực hiện",
    desc: "Áp dụng TCVN và 22 TCN trong tất cả quy trình thí nghiệm",
  },
  {
    icon: "ri-microscope-line",
    title: "Thiết bị hiện đại",
    desc: "Trang bị máy móc, thiết bị thí nghiệm tiên tiến, được hiệu chỉnh định kỳ",
  },
  {
    icon: "ri-user-star-line",
    title: "Đội ngũ chuyên môn",
    desc: "Kỹ sư và kỹ thuật viên được đào tạo bài bản, có kinh nghiệm thực tế",
  },
  {
    icon: "ri-timer-flash-line",
    title: "Kết quả nhanh chóng",
    desc: "Cam kết trả kết quả đúng hạn, hỗ trợ kỹ thuật 24/7 khi cần thiết",
  },
];

export default function CapabilitiesSection() {
  return (
    <section id="capabilities" className="py-14 md:py-20 bg-[#F5F7F2]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-[#0E5C3A] text-sm font-semibold uppercase tracking-widest mb-3">
            <i className="ri-bar-chart-line"></i>
            Năng lực
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mt-2">
            NĂNG LỰC &amp; CHỨNG NHẬN
          </h2>
          <div className="w-16 h-1 bg-[#D4A017] mx-auto mt-4 rounded-full"></div>
          <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">
            Được cấp phép và công nhận bởi cơ quan nhà nước có thẩm quyền, đảm bảo các kết quả thí nghiệm có giá trị pháp lý đầy đủ
          </p>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10 md:mb-14">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-white rounded-xl p-4 md:p-5 text-center border border-gray-100 hover:border-[#0E5C3A]/30 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#0E5C3A]/10 rounded-full mx-auto mb-3 text-[#0E5C3A]">
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div className="text-2xl font-bold text-[#0E5C3A]">
                {s.value}<span className="text-[#D4A017]">{s.unit}</span>
              </div>
              <div className="text-gray-500 text-xs mt-1 leading-tight">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Certifications grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {certifications.map((c) => (
            <div
              key={c.title}
              className="bg-white rounded-xl p-5 border border-gray-100 hover:border-[#0E5C3A]/30 transition-colors group"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0E5C3A]/10 rounded-lg text-[#0E5C3A] shrink-0 group-hover:bg-[#0E5C3A] group-hover:text-white transition-colors">
                  <i className={`${c.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-sm mb-1">{c.title}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Standards strip */}
        <div className="mt-8 bg-[#0E5C3A] rounded-xl p-5 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          <span className="text-white/70 text-sm">Tiêu chuẩn áp dụng:</span>
          {["TCVN", "22 TCN"].map((std) => (
            <span key={std} className="bg-white/15 text-white font-bold px-4 py-1.5 rounded-md text-sm tracking-wide">
              {std}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
